import React, {useCallback} from "react";
import "./DeliveryProviderForm/upload-delivery-provider-form.css";
import {createDeliveryProvider} from "../../../api/deliveryProvider/adminDeliveryProvider.js";
import {DeliveryProviderForm} from "./DeliveryProviderForm/DeliveryProviderForm.jsx";
import {useFormStateHook} from "../../../components/form/hook.jsx";
import {message} from "antd";

export const CreateDeliveryProvider = ({history, onSuccess}) => {
    const {formValues, onFormValueChange} = useFormStateHook([]);

    const onSave = useCallback(async () => {
        const {errors, ...restFormValues} = formValues;
        try {
            const deliveryProvider = await createDeliveryProvider(restFormValues);
            if (deliveryProvider?.error) {
                message.error(deliveryProvider?.error);
            } else {
                history.push(`upload/${deliveryProvider.deliveryProviderId}`);
                onSuccess();
            }
        } catch (e) {
            message.error(e?.message);
        }
    }, [formValues, history, onSuccess]);

    return (
        <>
            <DeliveryProviderForm formValues={formValues} setFormValues={onFormValueChange} onSave={onSave} />
        </>
    );
};
